import { IMobileOS } from '../serverApi/types/IMobileSecuritySettings';

export function getSeverityFieldsForPolicy(key: string): string[] {
  let severities: string[] = [];
  const supportedOSForPolicy = getSupportedOSForPolicy(key);
  supportedOSForPolicy.forEach(os => {
    if (os === IMobileOS.IOS) {
      severities.push(`settings.mobileSecuritySettings.${key}.iosConfig.severity`);
    } else if (os === IMobileOS.ANDROID) {
      severities.push(`settings.mobileSecuritySettings.${key}.androidConfig.severity`);
    }
  });
  return severities;
}

export function getValuesForPolicy(key: string): string[] {
  let values: string[] = [];
  const supportedOSForPolicy = getSupportedOSForPolicy(key);
  supportedOSForPolicy.forEach(os => {
    if (os === IMobileOS.IOS) {
      values.push(`settings.mobileSecuritySettings.${key}.iosConfig.value`);
    } else if (os === IMobileOS.ANDROID) {
      values.push(`settings.mobileSecuritySettings.${key}.androidConfig.value`);
    }
  });
  return values;
}

function getSupportedOSForPolicy(policy: string):  IMobileOS[] {
  switch (policy) {
  case 'jailbroken_device':
      return [IMobileOS.IOS, IMobileOS.ANDROID];
  case 'screenshot':
      return [IMobileOS.ANDROID];
  case 'max_offline':
    return [IMobileOS.IOS, IMobileOS.ANDROID];
  default:
      return [];
  }
}
